<template>
  <Carousel :autoplay="3000" :wrapAround="true">
    <Slide v-for="(slide, i) in slides" :key="slide"> 
      <a :href="slide.link"><img class="carousel__item" rel="preload" as="image" :src="slide.image" fetchpriority="high" :alt="(i+1)+' Slide'"/></a>
    </Slide>
    <template #addons>
      <Navigation />
      <Pagination />
    </template>
  </Carousel>
</template>

<script>
import { Carousel, Navigation, Pagination, Slide } from 'vue3-carousel'
export default {
  name: 'App',
  props: ["slidesdata"],
  data() {
    return {
      slides: []
    }
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  methods: {
    click(slide){
      if (slide.link) window.location.href = slide.link.replaceAll("eat-performance.com", "eat-performance.com")
    }
  },
  mounted(){
    this.slides = JSON.parse(this.slidesdata)
    // fetch('https://production.eat-performance.com/slides.json')
    //   .then(response => response.json())
    //   .then(data => {
    //     this.slides = data
    //   });
  }
}
</script>
